import { spacesSlice } from './slice';

export const {
  createSuccess,
  createStart,
  saveSpaces,
  addSpace,
  cancelAddSpace,
  setCurrentSpace,
  fetchDetailStart,
  fetchDetailSuccess,
  fetchDetailFailure,
  deleteStart,
  deleteSuccess,
  deleteFailure,
  editSpace,
  cancelEdit,
  editStart,
  editSuccess,
  editFailure,
  addSpaceTabsToSpace,
  removeSpaceTabFromSpace,
} = spacesSlice.actions;

export const spacesReducer = spacesSlice.reducer;

export * from './schema';
